import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const DetailView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{
                       paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%',
                       overflow: 'auto'
                   }}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={10}>
                        <TitlePage title="Administración \ Ejercicio de Derechos \ Detalle de Préstamos"/>
                    </Grid>
                    <Grid item xs={2} style={{textAlign: 'right'}}>
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnCorporateActionPage}
                                style={{visibility:'hidden'}}/>&nbsp;
                        <Button label="Buscar" onClick={props.getDataLoanCorporateAction}/>
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        {props.exportMenu}
                    </Grid>
                    <Grid item xs={12}>
                        <div className="content-section implementation">
                            <DataTable
                                value={props.mapInstitutions}
                                expandedRows={props.expandedRows}
                                onRowToggle={props.handleToggle}
                                rowExpansionTemplate={props.rowExpansionTemplate}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column expander={true} style={{width: '3em'}}/>
                                <Column field="nomCorto" header="Institución"
                                        style={{textAlign: 'left'}} sortable={true}/>
                            </DataTable>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default DetailView;